import { createContext, useContext, useMemo } from 'react'

const ModalDashboardContext = createContext()

// Hook for easy access
export const useModalDashboardContext = () => {
	const context = useContext(ModalDashboardContext)
	if (!context) {
		throw new Error('useModalDashboardContext must be used within a ModalDashboardProvider')
	}
	return context
}

// Pure provider — no internal logic, only exposes init values
export const ModalDashboardProvider = (props) => {
	const { passedIdValue, modalDashboardSetting, ...remainProps } = props
	const value = useMemo(
		() => ({
			passedIdValue,
			modalDashboardSetting,
		}),
		[passedIdValue, modalDashboardSetting]
	)

	return <ModalDashboardContext.Provider value={value} {...remainProps} />
}
